import ApiRequest from '../utils/ApiRequest'

export default class HighScore {
    getAllHighScores = async (gameId) => {
        return await ApiRequest.set(`/v1/highscore?game_type=` + gameId, 'GET')
    }
}
